export default __webpack_public_path__ + "static/Sonder_&_Tell_Logo-7355025c79ce4e27bc9bf243aaffaa3e.png";